import React, { Component } from 'react';
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { border } from '@mui/system';

class EditorConvertToHTML extends Component {
  constructor(props) {
    super(props);

    const html = props.value || '';
    const blocksFromHtml = htmlToDraft(html);
    const { contentBlocks, entityMap } = blocksFromHtml || { contentBlocks: [], entityMap: {} };
    const contentState = contentBlocks.length
      ? ContentState.createFromBlockArray(contentBlocks, entityMap)
      : ContentState.createFromText('');

    this.state = {
      editorState: EditorState.createWithContent(contentState),
    };
  }

  onEditorStateChange = (editorState) => {
    this.setState({ editorState });
    const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    
    if (this.props.onChange) {
      this.props.onChange(html);
    }
  };

  togglePreview = () => {
    this.setState({ showPreview: !this.state.showPreview });
  };

  render() {
    const { editorState, showPreview } = this.state;
    const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));

    const containerStyle = {
      minWidth: '100%',
      margin: '0 auto',
      // padding: '24px',
      backgroundColor: 'var(--card-bg, white)',
      fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    };

    const editorContainerStyle = {
      backgroundColor: 'var(--card-bg, white)',
      borderRadius: '12px',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
      border: '1px solid #e5e7eb',
      overflow: 'hidden',
    };

    const previewHeaderStyle = {
      fontSize: '18px',
      fontWeight: '600',
      color: '#374151',
      marginBottom: '16px',
      display: 'flex',
      alignItems: 'center',
    };

    const previewIconStyle = {
      width: '20px',
      height: '20px',
      marginRight: '8px',
    };

    const previewContainerStyle = {
      padding: '24px',
    };

    const previewContentStyle = {
      lineHeight: '1.7',
      fontSize: '16px',
      color: '#374151',
      maxWidth: 'none',
    };

    const statusBarStyle = {
      marginTop: '16px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontSize: '14px',
      color: '#6b7280',
    };

    const statusIndicatorStyle = {
      display: 'flex',
      alignItems: 'center',
    };

    const statusDotStyle = {
      width: '8px',
      height: '8px',
      backgroundColor: '#10b981',
      borderRadius: '50%',
      marginRight: '8px',
    };

    const editorStyles = {
      minHeight: '400px',
      padding: '24px',
      fontSize: '16px',
      lineHeight: '1.6',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      color: '#374151',
      backgroundColor: 'var(--card-bg, white)',
      border: 'none',
      outline: 'none',
    };

    const toolbarStyles = {
      border: 'none',
      borderBottom: '1px solid #e5e7eb',
      backgroundColor: '#f8fafc',
      padding: '16px 24px',
      marginBottom: '0',
    };

    const wrapperStyles = {
      border: 'none',
    };

    const wordCount = editorState.getCurrentContent().getPlainText('').split(' ').filter(word => word.length > 0).length;

    return (
      <div style={containerStyle}>
        {/* Header */}
        {/* <div style={headerStyle}>
          <h1 style={titleStyle}>Rich Text Editor</h1>
          <p style={subtitleStyle}>Create beautifully formatted content with our powerful editor</p>
        </div> */}

        {/* Toggle Buttons */}
        {/* <div style={buttonContainerStyle}>
          <button
            onClick={() => this.setState({ showPreview: false })}
            style={buttonStyle(!showPreview)}
          >
            Editor
          </button>
          <button
            onClick={() => this.setState({ showPreview: true })}
            style={buttonStyle(showPreview)}
          >
            Preview
          </button>
        </div> */}

        {/* Editor Container */}
        <div style={editorContainerStyle}>
          {!showPreview ? (
            <div className="editor-wrapper">
              <Editor
                editorState={editorState}
                onEditorStateChange={this.onEditorStateChange}
                toolbar={{
                  options: [
                    'inline',
                    'blockType',
                    'fontSize',
                    'fontFamily',
                    'list',
                    'textAlign',
                    'colorPicker',
                    'link',
                    'embedded',
                    'emoji',
                    'image',
                    'remove',
                    'history',
                  ],
                  inline: {
                    inDropdown: false,
                    options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace', 'superscript', 'subscript'],
                  },
                  blockType: {
                    inDropdown: true,
                    options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote', 'Code'],
                  },
                  fontSize: {
                    options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
                  },
                  fontFamily: {
                    options: ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana', 'Serif', 'Sans-Serif', 'Monospace'],
                  },
                  list: {
                    inDropdown: false,
                    options: ['unordered', 'ordered', 'indent', 'outdent'],
                  },
                  textAlign: {
                    inDropdown: false,
                    options: ['left', 'center', 'right', 'justify'],
                  },
                  colorPicker: {
                    colors: ['rgb(97,189,109)', 'rgb(26,188,156)', 'rgb(84,172,210)', 'rgb(44,130,201)',
                      'rgb(147,101,184)', 'rgb(71,85,119)', 'rgb(204,204,204)', 'rgb(65,168,95)', 'rgb(0,168,133)',
                      'rgb(61,142,185)', 'rgb(41,105,176)', 'rgb(85,57,130)', 'rgb(40,50,78)', 'rgb(0,0,0)',
                      'rgb(247,218,100)', 'rgb(251,160,38)', 'rgb(235,107,86)', 'rgb(226,80,65)', 'rgb(163,143,132)',
                      'rgb(239,239,239)', 'rgb(255,255,255)', 'rgb(250,197,28)', 'rgb(243,121,52)', 'rgb(209,72,65)',
                      'rgb(184,49,47)', 'rgb(124,112,107)', 'rgb(209,213,216)'],
                  },
                  link: {
                    inDropdown: false,
                    showOpenOptionOnHover: true,
                    defaultTargetOption: '_self',
                    options: ['link', 'unlink'],
                  },
                  emoji: {
                    emojis: [
                      '😀', '😁', '😂', '😃', '😉', '😋', '😎', '😍', '😗', '🤗', '🤔', '😣', '😫', '😴', '😌', '🤓',
                      '😛', '😜', '😠', '😇', '😷', '😈', '👻', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '🙈',
                      '🙉', '🙊', '👼', '👮', '🕵', '💂', '👳', '🎅', '👸', '👰', '👲', '🙍', '🙎', '🙅', '🙆', '💁', '🙋', '💆', '💇', '💃'
                    ],
                  },
                  embedded: {
                    defaultSize: {
                      height: 'auto',
                      width: 'auto',
                    },
                  },
                  image: {
                    urlEnabled: true,
                    uploadEnabled: true,
                    alignmentEnabled: true,
                    previewImage: false,
                    inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                    alt: { present: false, mandatory: false },
                    defaultSize: {
                      height: 'auto',
                      width: 'auto',
                    },
                  },
                }}
                editorStyle={editorStyles}
                wrapperStyle={wrapperStyles}
                toolbarStyle={toolbarStyles}
              />
            </div>
          ) : (
            <div style={previewContainerStyle}>
              <h3 style={previewHeaderStyle}>
                <svg style={previewIconStyle} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
                Preview
              </h3>
              <div 
                style={previewContentStyle}
                dangerouslySetInnerHTML={{ 
                  __html: html || '<p style="color: #9ca3af; font-style: italic;">Start typing in the editor to see your content here...</p>' 
                }}
              />
            </div>
          )}
        </div>

        {/* Word Count and Status */}
        <div style={statusBarStyle}>
          <div>Words: {wordCount}</div>
          <div style={statusIndicatorStyle}>
            <div style={statusDotStyle}></div>
            Ready
          </div>
        </div>

        <style>{`
          .editor-wrapper .rdw-editor-toolbar {
            border: none !important;
            background-color: #f8fafc !important;
            border-bottom: 1px solid #e5e7eb !important;
            padding: 16px 24px !important;
            margin-bottom: 0 !important;
          }
          
          .editor-wrapper .rdw-editor-main {
            border: none !important;
          }
          
          .editor-wrapper .rdw-option-wrapper {
            border: 1px solid #e5e7eb !important;
            border-radius: 6px !important;
            margin: 0 2px !important;
            transition: all 0.2s ease !important;
            background-color: #ffffff !important;
          }
          
          .editor-wrapper .rdw-option-wrapper:hover {
            background-color: #f3f4f6 !important;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
            transform: translateY(-1px) !important;
          }
          
          .editor-wrapper .rdw-option-active {
            background-color: #dbeafe !important;
            border-color: #3b82f6 !important;
            color: #1d4ed8 !important;
          }
          
          .editor-wrapper .rdw-dropdown-wrapper {
            border: 1px solid #e5e7eb !important;
            border-radius: 6px !important;
            background-color: white !important;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;
          }
          
          .editor-wrapper .rdw-dropdown-selectedtext {
            color: #374151 !important;
            font-weight: 500 !important;
          }
          
          .editor-wrapper .rdw-dropdown-optionwrapper {
            background-color: #ffffff !important;
          }
          
          .editor-wrapper .rdw-dropdown-optionwrapper:hover {
            background-color: #f8fafc !important;
          }
          
          .preview-content h1 {
            font-size: 36px;
            font-weight: 700;
            color: #1f2937;
            margin-bottom: 16px;
            line-height: 1.2;
            border-bottom: 2px solid #e5e7eb;
            padding-bottom: 8px;
          }
          
          .preview-content h2 {
            font-size: 30px;
            font-weight: 600;
            color: #374151;
            margin-bottom: 14px;
            margin-top: 32px;
            line-height: 1.3;
          }
          
          .preview-content h3 {
            font-size: 24px;
            font-weight: 600;
            color: #374151;
            margin-bottom: 12px;
            margin-top: 24px;
            line-height: 1.3;
          }
          
          .preview-content h4 {
            font-size: 20px;
            font-weight: 600;
            color: #4b5563;
            margin-bottom: 10px;
            margin-top: 20px;
            line-height: 1.4;
          }
          
          .preview-content h5 {
            font-size: 18px;
            font-weight: 600;
            color: #4b5563;
            margin-bottom: 8px;
            margin-top: 16px;
            line-height: 1.4;
          }
          
          .preview-content h6 {
            font-size: 16px;
            font-weight: 600;
            color: #6b7280;
            margin-bottom: 8px;
            margin-top: 16px;
            line-height: 1.4;
          }
          
          .preview-content p {
            margin-bottom: 16px;
            line-height: 1.7;
            color: #374151;
          }
          
          .preview-content blockquote {
            border-left: 4px solid #3b82f6;
            padding-left: 16px;
            margin: 24px 0;
            font-style: italic;
            color: #6b7280;
            background-color: #f8fafc;
            padding: 16px;
            border-radius: 0 8px 8px 0;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          }
          
          .preview-content ul, .preview-content ol {
            margin-bottom: 16px;
            padding-left: 24px;
          }
          
          .preview-content li {
            margin-bottom: 4px;
            line-height: 1.6;
          }
          
          .preview-content strong {
            font-weight: 600;
            color: #1f2937;
          }
          
          .preview-content em {
            font-style: italic;
            color: #4b5563;
          }
          
          .preview-content code {
            background-color: #f3f4f6;
            padding: 4px 6px;
            border-radius: 4px;
            font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
            font-size: 14px;
            color: #dc2626;
            border: 1px solid #e5e7eb;
          }
          
          .preview-content a {
            color: #2563eb;
            text-decoration: underline;
            text-decoration-color: #93c5fd;
            text-underline-offset: 2px;
            transition: all 0.2s ease;
          }
          
          .preview-content a:hover {
            color: #1d4ed8;
            text-decoration-color: #60a5fa;
          }
          
          .preview-content img {
            max-width: 100%;
            height: auto;
            border-radius: 8px;
            margin: 16px 0;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
          }
          
          .preview-content table {
            width: 100%;
            border-collapse: collapse;
            margin: 16px 0;
          }
          
          .preview-content th, .preview-content td {
            border: 1px solid #e5e7eb;
            padding: 8px 12px;
            text-align: left;
          }
          
          .preview-content th {
            background-color: #f9fafb;
            font-weight: 600;
            color: #374151;
          }
        `}</style>
      </div>
    );
  }
}

export default EditorConvertToHTML;